export function getVersion() {
  const version = import.meta.env.VITE_APP_VERSION
  const buildDate = import.meta.env.VITE_BUILD_DATE
  const commitHash = import.meta.env.VITE_GIT_COMMIT_HASH

  return {
    version,
    buildDate,
    commitHash,
  }
}
